module.exports = __webpack_public_path__ + "img/1543623331.96c5b981.jpg";